<script>
import { reactive } from '@vue/composition-api'
import isBeforeEventDate from '@/mixins/isef'

const banners2023 = [
  {
    name: 'Regeneron',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fregeneron.png?alt=media&token=1de2a1a3-7e78-47e0-9cb8-a7eef3e949b9',
    link: 'https://www.regeneron.com'
  },
  {
    name: 'Akamai Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fakamai.png?alt=media&token=4295a892-0e61-455e-ae92-d117e3e7d7f6',
    link: 'https://www.akamai.com/company/corporate-responsibility/akamai-foundation'
  },
  {
    name: 'Beal Bank',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fbeal_bank.png?alt=media&token=7f88c0a5-7db2-4c0b-ab33-023c5aedf8d4',
    link: 'http://bealbank.com'
  },
  {
    name: 'Gordon and Betty Moore Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FGordan%20and%20betty.png?alt=media&token=088cbe30-d9ab-45c2-9ae7-e6e4d4c65e9a',
    link: 'https://www.moore.org'
  },
  {
    name: 'Howmet Aerospace Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fhaf.png?alt=media&token=c0be54fc-c157-4ab0-ba45-342b14b68c24',
    link: 'https://www.howmet.com'
  },
  {
    name: 'Jacobs',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fjacobs.png?alt=media&token=a48b7c13-c6ec-4099-9247-acb383d5554f',
    link: 'https://www.jacobs.com'
  },
  {
    name: 'King Abdulaziz & his Companions Foundation for Giftedness & Creativity',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FKing%20Abdulaziz%20.png?alt=media&token=dd7f8261-463e-4181-a474-6b5730af36a0',
    link: 'https://www.mawhiba.org/en/About/Pages/default.aspx'
  },
  {
    name: 'Lyda Hill Philanthropies',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FLyda.png?alt=media&token=2a690633-6005-47f3-9b16-94a19f915873',
    link: 'https://www.lydahillphilanthropies.org'
  },
  {
    name: 'Microsoft',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fmicrosoft.png?alt=media&token=ca18845c-ad5e-43f6-bf1f-610e07fa3dbb',
    link: 'https://www.microsoft.com/en-us/about'
  },
  {
    name: 'National Geographic Society',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fnat_geo.png?alt=media&token=fbed26f8-dae0-4998-8ea3-834817f37c36',
    link: 'https://www.nationalgeographic.org/society/'
  },
  {
    name: 'Perot Museum of Nature and Science',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FPerot.png?alt=media&token=996a2695-1dee-440c-bc63-a915b5e3b284',
    link: 'https://www.perotmuseum.org'
  },
  {
    name: 'Richard F. Caris Charitable Trust II',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Frichard%20f.png?alt=media&token=22cb48cb-d04c-4730-b3fe-d118379f2a87',
    link: 'https://www.interfaceforce.com'
  },
  {
    name: 'Rise',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FRise.png?alt=media&token=65a3fd88-e350-4d7e-a1ff-31d4bb54860b',
    link: 'https://www.schmidtfutures.com/our-work/rise/'
  },
  {
    name: 'Robert I. Schattner Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Frobert.png?alt=media&token=8e5aef6a-5a44-4ec3-9ad5-300080b42061',
    link: 'https://robertischattnerfoundation.org'
  },
  {
    name: 'Siemens Energy',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fseimens.png?alt=media&token=7c496ae3-741b-441d-b2fe-9ee297eb778d',
    link: 'https://www.siemens-energy.com'
  },
  {
    name: 'Texas A&M University',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FTexas%20A%26M.png?alt=media&token=6f358220-264c-4785-adce-c019137babdb',
    link: 'https://www.tamu.edu'
  },
  {
    name: 'Cesco Linguistic Services',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FCesco.png?alt=media&token=4a9a1976-4aa8-4d33-805c-66b9a42a7203',
    link: 'https://cescols.com/'
  },
  {
    name: 'Insaco',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FINSACO.png?alt=media&token=68332343-a12c-4a21-99f9-1c38efebb9d5',
    link: 'https://www.insaco.com/'
  },
  {
    name: 'Oracle Academy',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FOracle.png?alt=media&token=27a83823-97d9-4296-a803-4a7d3691b6f9',
    link: 'https://www.oracle.com'
  },
  {
    name: 'Southern Methodist University',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FSMU.png?alt=media&token=688f37f4-5d24-40bd-91ac-27f90fd0eda7',
    link: 'https://www.smu.edu'
  },
  {
    name: 'The University of Texas at Dallas',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FUTD.png?alt=media&token=f6f0b301-9586-46c4-8774-9fc6e49f954a',
    link: 'http://utdallas.edu/'
  },
  {
    name: 'Army ROTC',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FArmy%20ROTC.png?alt=media&token=c583faf1-738a-4628-8b5b-5c5da01f3cef',
    link: 'https://www.goarmy.com/careers-and-jobs/find-your-path/army-officers/rotc.html'
  },
  {
    name: 'ExxonMobil',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FExxon.png?alt=media&token=6aeeec73-d3d2-4c67-bb3f-89bd881ea756',
    link: 'https://corporate.exxonmobil.com'
  },
  {
    name: 'The Hoglund Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FHoflund.png?alt=media&token=4ba03aec-5809-40ed-b9a7-a89725ae3345',
    link: 'https://www.hoglundfoundation.org/'
  },
  {
    name: 'Society For Science',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fsociety_for_science.png?alt=media&token=31418650-1f91-4576-8a18-eef0a208a779',
    link: 'https://www.societyforscience.org/'
  }
]
const banners2024 = [
  {
    name: 'Regeneron',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FRegeneron.png?alt=media&token=8b7bc3b4-2d84-4d58-8f97-f89dac69e91f',
    link: 'https://www.regeneron.com'
  },
  {
    name: 'Akamai Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fakamai.png?alt=media&token=4295a892-0e61-455e-ae92-d117e3e7d7f6',
    link: 'https://www.akamai.com/company/corporate-responsibility/akamai-foundation'
  },
  {
    name: 'Alfred E Mann Charities',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FAlfredEMannCharities.png?alt=media&token=41712472-c216-45f6-800f-e3254d42a919',
    link: 'https://aemanncharities.org'
  },
  {
    name: 'Gordon and Betty Moore Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FGordan%20and%20betty.png?alt=media&token=088cbe30-d9ab-45c2-9ae7-e6e4d4c65e9a',
    link: 'https://www.moore.org'
  },
  {
    name: 'Howmet Aerospace Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FHowmetAerospaceFoundation.png?alt=media&token=2de6eeaf-9955-4abb-a3ce-abf70c7a240b',
    link: 'https://www.howmet.com'
  },
  {
    name: 'Jacobs',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fjacobs.png?alt=media&token=a48b7c13-c6ec-4099-9247-acb383d5554f',
    link: 'https://www.jacobs.com'
  },
  {
    name: 'King Abdulaziz & his Companions Foundation for Giftedness & Creativity',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FKing%20Abdulaziz%20.png?alt=media&token=dd7f8261-463e-4181-a474-6b5730af36a0',
    link: 'https://www.mawhiba.org/en/About/Pages/default.aspx'
  },
  {
    name: 'Microsoft',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FMicrosoft.png?alt=media&token=de4f8874-5357-47d4-a4d1-c6fa46f301bd',
    link: 'https://www.microsoft.com/en-us/about'
  },
  {
    name: 'Hewlett Packard',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FHP.png?alt=media&token=f77a3bce-3f85-4945-a7f2-0e432127e1c9',
    link: 'https://www.hp.com/ca-en/hp-information.html'
  },
  {
    name: 'National Geographic Society',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FNatGeo.png?alt=media&token=7b694797-12ec-4f67-a451-66b9f07ce8086',
    link: 'https://www.nationalgeographic.org/society/'
  },
  {
    name: 'Richard F. Caris Charitable Trust II',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Frichard%20f.png?alt=media&token=22cb48cb-d04c-4730-b3fe-d118379f2a87',
    link: 'https://www.interfaceforce.com'
  },
  {
    name: 'Rise',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FRise.png?alt=media&token=65a3fd88-e350-4d7e-a1ff-31d4bb54860b',
    link: 'https://www.schmidtfutures.com/our-work/rise/'
  },
  {
    name: 'Schattner Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FRobertSchattnerFoundation.png?alt=media&token=abcfed46-a811-4464-8dcd-6bb8c7f62139',
    link: 'https://robertischattnerfoundation.org'
  },
  {
    name: 'Ralph M. Parsons Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FTheRalphM.Parsons.png?alt=media&token=796a34d7-ef5b-40b1-b89e-740c7372f13e',
    link: 'https://rmpf.org'
  },
  {
    name: 'Siemens Energy',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fseimens.png?alt=media&token=7c496ae3-741b-441d-b2fe-9ee297eb778d',
    link: 'https://www.siemens-energy.com'
  },
  {
    name: 'Cesco Linguistic Services',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FCesco.png?alt=media&token=4a9a1976-4aa8-4d33-805c-66b9a42a7203',
    link: 'https://cescols.com/'
  },
  {
    name: 'Insaco',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FINSACO.png?alt=media&token=68332343-a12c-4a21-99f9-1c38efebb9d5',
    link: 'https://www.insaco.com/'
  },
  {
    name: 'Oracle Academy',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2FOracle.png?alt=media&token=27a83823-97d9-4296-a803-4a7d3691b6f9',
    link: 'https://www.oracle.com'
  },
  {
    name: 'Army ROTC',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FArmyROTC.png?alt=media&token=a207cbf0-109c-4d18-b8ba-740f7100ab86',
    link: 'https://www.goarmy.com/careers-and-jobs/find-your-path/army-officers/rotc.html'
  },
  {
    name: 'Board Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FBroadFoundation.png?alt=media&token=2d89d57a-bca0-47d9-8b12-69c550f487a5',
    link: 'https://broadfoundation.org'
  },
  {
    name: 'Broadcom Foundation',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FBroadcomFoundation.png?alt=media&token=13bc5516-a72c-4bff-b1e9-b9f0128344f0',
    link: 'https://broadcomfoundation.org'
  },
  {
    name: 'Society For Science',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fsponsors%2Fsociety_for_science.png?alt=media&token=31418650-1f91-4576-8a18-eef0a208a779',
    link: 'https://www.societyforscience.org/'
  }
]

const sponsors = reactive({
  sponsor: {
    name: 'Regeneron',
    url: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2024%2Fsponsors%2FRegeneron.png?alt=media&token=8b7bc3b4-2d84-4d58-8f97-f89dac69e91f',
    link: 'https://www.regeneron.com'
  },
  banner: [],
  notHome: [
    'Regeneron'
  ],
  notCategories: [
    'Perot Museum of Nature and Science',
    'King Abdulaziz & his Companions Foundation for Giftedness & Creativity',
    'Lyda Hill Philanthropies',
    'Texas A&M University',
    'Rise',
    'Gordon and Betty Moore Foundation',
    'Cesco Linguistic Services',
    'Southern Methodist University',
    'The University of Texas at Dallas',
    'Oracle Academy',
    'ExxonMobil',
    'Army ROTC',
    'The Hoglund Foundation',
    'Insaco'
  ]
})

export default {
  data () {
    return {
      sponsors
    }
  },
  mixins: [isBeforeEventDate],
  computed: {
    isCategories: function () {
      return this.$route.name === 'isefCategories'
    }
  },
  methods: {
    filterSponsors: function (sponsors, input) {
      if (sponsors?.length > 0) {
        if (input) {
          if (Array.isArray(input)) {
            return sponsors.filter(sponsor => !input.includes(sponsor.name))
          }
          return sponsors.filter(sponsor => sponsor.name !== input)
        }
        return sponsors
      } else {
        return []
      }
    }
  },
  mounted () {
    sponsors.banner = this.$isProduction && this.isBeforeEventDate('May 4, 2024') ? banners2023 : banners2024
  }
}
</script>

<template>
  <div class="isef-sponsor-banner">
    <div class="isef-sponsor-banner-title">
      <span class="isef-sponsor-banner-title-container"
            :class="{'isef-sponsor-banner-title-container-homepage' : !isCategories}">
        <h3 class="isef-sponsor-banner-title-name">
          {{ isCategories ? 'Category Sponsors' : 'Title Sponsor' }}
        </h3>
        <a :href="sponsors.sponsor.link" target="_blank">
        <img v-if="!isCategories"
             :src="sponsors.sponsor.url"
             :alt="sponsors.sponsor.name"
             class="isef-sponsor-banner-title-image"/>
        </a>
      </span>
    </div>
    <div class="marquee marquee--fit-content enable-animation marquee--hover-pause">
      <ul class="marquee__content">
        <li v-for="sponsor in filterSponsors(sponsors.banner, isCategories
        ? sponsors.notCategories : sponsors.notHome)"
            :key="sponsor.name">
          <a :href="sponsor.link" target="_blank">
            <img :src="sponsor.url"
                 class="marquee-image"
                 :alt="sponsor.name" />
          </a>
        </li>
      </ul>
      <ul aria-hidden="true"
          class="marquee__content">
        <li v-for="sponsor in filterSponsors(sponsors.banner, isCategories
        ? sponsors.notCategories : sponsors.notHome)"
            :key="sponsor.name"
            class="marquee-image-container">
            <a :href="sponsor.link" target="_blank">
                <img :src="sponsor.url"
                     class="marquee-image"
                     :alt="sponsor.name" />
            </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$animationSpeed: 45s;

/* Marquee styles Starting*/
// Reference article => https://codepen.io/hexagoncircle/pen/eYMrGwW
.marquee {
  --gap: 1rem;
  position: relative;
  display: flex;
  overflow: hidden;
  user-select: none;
  gap: var(--gap);
  background-color: white;
  &__content {
    z-index: 2;
    flex-shrink: 0;
    display: flex;
    justify-content: space-around;
    gap: var(--gap);
    min-width: 100%;
  }
  &-image {
    max-height: 3rem;
    width: auto;
  }
}

@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(calc(-100% - var(--gap)));
  }
}

/* Pause animation when reduced-motion is set */
//@media (prefers-reduced-motion: reduce) {
//  .marquee__content {
//    animation-play-state: paused !important;
//  }
//}

/* Enable animation */
.enable-animation .marquee__content {
  animation: scroll $animationSpeed linear infinite;
  animation-delay: 2s;
}

/* Pause on hover */
.marquee--hover-pause:hover .marquee__content {
  animation-play-state: paused;
}

/* Attempt to size parent based on content. Keep in mind that the parent width is equal to both content containers that stretch to fill the parent. */
.marquee--fit-content {
  max-width: fit-content;
}

/* A fit-content sizing fix: Absolute position the duplicate container. This will set the size of the parent wrapper to a single child container. Shout out to Olavi's article that had this solution 👏 @link: https://olavihaapala.fi/2021/02/23/modern-marquee.html  */
.marquee--pos-absolute .marquee__content:last-child {
  position: absolute;
  top: 0;
  left: 0;
}

/* Enable position absolute animation on the duplicate content (last-child) */
.enable-animation .marquee--pos-absolute .marquee__content:last-child {
  animation-name: scroll-abs;
}

@keyframes scroll-abs {
  from {
    transform: translateX(calc(100% + var(--gap)));
  }
  to {
    transform: translateX(0);
  }
}

/* Other page demo styles */
.marquee__content > * {
  flex: 0 0 auto;
  color: white;
  margin: 0 2px 2px 2px;
  padding-top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 150px;
  border-radius: 0.25rem;
  text-align: center;
}
// Marquee Style Ending

@mixin white-gradient {
  background: linear-gradient(to right,  rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);
}

// Sponsor
.isef-sponsor-banner {
  overflow: hidden;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2FVector.png?alt=media&token=b99984c2-1a4f-4551-af8f-c41c83f77a31");
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 10px -5px rgba(0, 0, 0, .125);
  height: 62px;
  padding-top: .75rem;
  z-index: 2;
  @media only screen and (max-width: 550px) {
    flex-direction: column;
    background-repeat: no-repeat;
    height: 100%;
    justify-content: unset;
    align-items: unset;
  }
  &-title {
    @media only screen  and (max-width: 900px){
      padding-bottom: .5rem;
    }
    @media only screen and (max-width: 600px){
      margin-top: .8rem;
      padding-bottom: .1rem;
    }
    &-container {
      margin-top: .5rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @media only screen and (max-width: 900px) {
        align-items: center;
      }
      @media only screen and (max-width: 600px) {
        width: 100%;
        margin-top: 0;
      }
      height: 100%;
      width: 10rem;
      margin-left: 1rem;
      &-homepage {
        margin-left: 15rem;
        @media only screen and (max-width: 1800px) {
          margin-left: 2rem;
        }
        @media only screen and (max-width: 600px){
          margin-left: 0;
        }
      }
    }
    &-name {
      font-family: 'Trade Gothic Next LT Pro BdCn', sans-serif;
      letter-spacing: 0.01em;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      text-transform: uppercase;
      margin-top: -.3rem;
      padding-bottom: .1rem;
      @media only screen  and (max-width: 900px){
        margin-top: 0;
        font-size: 1em;
        text-align: center;
        padding-bottom: 0;
      }
    }
    &-image {
      width: 120px;
    }
  }
}
</style>
